var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuctionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 96 96",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_29-auction",
    "data-name": "29-auction"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 88h56v8h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 79.935a4 4 0 0 0 -4-4h-32a4 4 0 0 0 -4 4v4.065h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.426 47.231a27.906 27.906 0 0 0 -4.639 6.674l32.924 32.924a4 4 0 0 0 5.656 0l5.657-5.657a4 4 0 0 0 0-5.657l-32.924-32.915a27.263 27.263 0 0 0 -6.674 4.631z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.627 27.432a34.686 34.686 0 0 1 -10.34 6.629l20.674 20.674a35.253 35.253 0 0 1 6.639-10.335 34.715 34.715 0 0 1 10.34-6.63l-20.675-20.67a35.282 35.282 0 0 1 -6.638 10.332z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 4,
    transform: "matrix(.707 -.707 .707 .707 4.201 48.034)",
    width: 16,
    x: 52.083,
    y: -1.054
  }), /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 4,
    transform: "matrix(.707 -.707 .707 .707 -29.74 33.976)",
    width: 16,
    x: 18.142,
    y: 32.887
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionIcon);
export default __webpack_public_path__ + "static/media/auction_icon.dd100389.svg";
export { ForwardRef as ReactComponent };